import type businessDocumentVM from "../../../BusinessDocuments/BusinessDocumentSelector/businessDocumentVM";
import { type ProductReturnRequestItemViewModel, productReturnRequestItemViewModelToServerModel } from "./ProductReturnRequestItemViewModel";
import { type AttachmentViewModel, attachmentViewModelToServerModel } from "./AttachmentViewModel";
import type { ProductReturnRequestServerVM } from "./ProductReturnRequestServerVM";

export interface ViewModel {
  customerRepName: string;
  customerRepEMail: string;
  customerRepPhone: string;
  comments: string | null;
  salesDocument: businessDocumentVM | null;
  items: ProductReturnRequestItemViewModel[];
  attachments: AttachmentViewModel[];
}

export function complaintViewModelToServerModel(
  vm: ViewModel
): ProductReturnRequestServerVM {
  const r: ProductReturnRequestServerVM = {
    customerRepName: vm.customerRepName,
    customerRepEMail: vm.customerRepEMail,
    customerRepPhone: vm.customerRepPhone,
    comments: vm.comments,
    // biome-ignore lint/style/noNonNullAssertion: at the point when the conversion is called, the salesDocument should have been selected, so it's safe to use non-null assertion here.
    salesDocumentNumber: vm.salesDocument?.documentNumber!,
    productReturnRequestItemVMs: vm.items.map((x) =>
      productReturnRequestItemViewModelToServerModel(x)
    ),
    productReturnRequestAttachmentVMs: vm.attachments.map((x) =>
      attachmentViewModelToServerModel(x)
    ),
  };

  return r;
}




